import type { ComponentType, ReactNode, SVGProps } from 'react';
import { Link } from 'react-router-dom';

import { Button, Card, CardContent } from '@/components/cargofl-ui';
import { PageContainer } from '@/components/shell/page-container';

/**
 * The one layout for a page that cannot be shown — 404, 403 — inside the shell, so the
 * sidebar stays and the way out is one click. The code is printed because it is what
 * someone reads out when they report it.
 */
export function ErrorPage({
  code,
  art: Art,
  title,
  body,
  children = (
    <Button asChild variant="outline">
      <Link to="/dashboard">Back to dashboard</Link>
    </Button>
  ),
}: {
  code: number;
  art: ComponentType<SVGProps<SVGSVGElement>>;
  title: string;
  body: string;
  children?: ReactNode;
}) {
  return (
    <PageContainer>
      <Card>
        <CardContent className="space-y-4 py-12 sm:py-12">
          <Art className="h-24 w-auto" />
          <p className="pms-num text-3xl font-bold text-muted-foreground">{code}</p>
          <div className="space-y-1">
            <h1 className="text-lg font-semibold">{title}</h1>
            <p className="text-sm text-muted-foreground">{body}</p>
          </div>
          {children}
        </CardContent>
      </Card>
    </PageContainer>
  );
}
